import { useScrollFadeIn } from '../../../hooks/useScrollFadeIn';

export default function Overview() {
  const { ref, isVisible } = useScrollFadeIn({ delay: 150 });

  return (
    <section
      ref={ref}
      className={`py-20 md:py-40 px-5 md:px-6 bg-white transition-all duration-1000 ease-out ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
      }`}
    >
      <div className="max-w-3xl mx-auto text-center">

        {/* セクション見出し */}
        <p className="text-xs tracking-[0.35em] uppercase text-gray-400 font-semibold mb-6">
          Special Offer
        </p>
        <h2 className="text-3xl md:text-6xl font-black text-gray-900 leading-[1.1] tracking-tight mb-6">
          新生活を、価格の壁で<br />諦めてほしくないから。
        </h2>
        <p className="text-base md:text-lg text-gray-500 leading-[1.9] tracking-wide max-w-xl mx-auto mb-16 md:mb-28">
          理想のフラッグシップチェアを追求しながら、<br className="hidden md:block" />
          新しい門出を迎えるすべての人へ届けたい。
        </p>

        {/* 通常価格 */}
        <p className="text-xs tracking-[0.3em] uppercase text-gray-400 font-medium mb-3">
          通常販売価格（税込）
        </p>
        <p className="text-4xl md:text-7xl font-black text-gray-300 line-through tracking-tight mb-8 md:mb-14">
          ¥128,700
        </p>

        {/* 矢印 */}
        <div className="flex flex-col items-center gap-2 mb-8 md:mb-14">
          <i className="ri-arrow-down-line text-3xl md:text-4xl text-gray-300"></i>
          <p className="text-sm font-semibold tracking-widest text-gray-400 uppercase">
            先行予約限定
          </p>
        </div>

        {/* 特別価格 */}
        <p className="text-xs tracking-[0.3em] uppercase text-purple-500 font-semibold mb-4">
          今回のみの特別価格（税込）
        </p>
        <p className="text-6xl md:text-[9rem] font-black text-gray-900 tracking-tight leading-none mb-6 md:mb-8">
          ¥89,650
        </p>

        {/* 割引バッジ */}
        <div className="inline-flex items-center gap-2 px-6 md:px-8 py-3 bg-gray-900 text-white rounded-full mb-4">
          <i className="ri-price-tag-3-fill text-base"></i>
          <span className="text-base md:text-xl font-bold">Save ¥39,050（30% OFF）</span>
        </div>
        <p className="text-sm text-gray-400 mb-16 md:mb-28">送料無料</p>

        {/* 区切り線 */}
        <div className="w-16 h-px bg-gray-200 mx-auto mb-16 md:mb-28"></div>

        {/* CTAボタン */}
        <a
          href="https://mever.design/products/mever-chair-pro-ver2"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block w-full md:w-auto px-10 md:px-14 py-5 bg-gray-900 hover:bg-gray-700 active:scale-[0.97] text-white text-lg md:text-xl font-bold rounded-full transition-all duration-300 hover:shadow-xl whitespace-nowrap cursor-pointer"
        >
          今すぐ予約する →
        </a>

        {/* サブ情報 */}
        <div className="flex items-center justify-center gap-2 md:gap-3 flex-wrap mt-6 text-xs md:text-sm text-gray-400 px-4">
          <span>先行予約限定 30%OFF</span>
          <span className="text-gray-300">·</span>
          <span className="text-gray-700 font-semibold">各色50脚限定</span>
          <span className="text-gray-300">·</span>
          <span>ブラック・グレー</span>
        </div>

        {/* 返品保証リンク */}
        <a
          href="https://mever.design/pages/30%E6%97%A5%E9%96%93%E8%BF%94%E9%87%91%E4%BF%9D%E8%A8%BC%E3%83%9D%E3%83%AA%E3%82%B7%E3%83%BC"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 mt-5 text-sm text-gray-400 hover:text-gray-700 font-medium transition-colors cursor-pointer min-h-[44px]"
        >
          <i className="ri-shield-check-line text-base"></i>
          30日間返品保証について
        </a>

      </div>
    </section>
  );
}